import {tokenDefinition} from "../../token/tokenDefinition.mjs";
import {TokenType} from "../../token/tokenType.mjs";
import {TokenName} from "./tokenName.mjs";
import {NodeName} from "./nodeName.mjs";
import {Node} from "../../node/node.mjs";

const lineFeed = tokenDefinition({
    name: TokenName.LINE_FEED,
    type: TokenType.DELIMITER,
    tokenMatcher: /^\n/,
    contentMatcher: /^\n/
});

class LineFeed {

    constructor() {

    }

    consume(tokenIterator, nodeIterator) {

       if(this.isLineFeed(tokenIterator)) {
           nodeIterator.addClosedNode(
               new Node(NodeName.LINE_FEED, "\n", null, nodeIterator.currentParentNode).close()
           )

           tokenIterator.eatTokens(1)
       }
    }

    onEndOfMarkup(openNode) {
    }

    toHtml(node, toHtml, idProvider) {
        return "<br>"
    }

    isLineFeed(tokenIterator) {
        return tokenIterator.token().name === TokenName.LINE_FEED
    }

}

export {lineFeed, LineFeed}